import * as React from "react"
import ContactPage from "../components/contact/contact-page"

const seo = {
    title: "Book a virtual demo of Vibra One",
    description: "See Vibra One on a live video call: the door, the light, the ventilation and the sound from inside and outside. Twenty minutes, no obligation.",
}

const VirtualDemo = () => (
    <ContactPage
        seo={seo}
        title="Book a virtual demo"
        intro={
            <div style={{ marginBottom: 30 }}>
                <p>
                    A specification cannot tell you how a booth feels. In a twenty-minute video call we walk you around Vibra One, open and close the door, switch the light and fan on, and let you hear a phone call from inside and from outside. Bring your floor plan and we will talk through where booths would work in your office.
                </p>
                <p>Leave your details and a good time to call, and we will confirm a slot by email.</p>
            </div>
        }
    />
)

export default VirtualDemo
